// Libs
import React, { useEffect, useState } from 'react';
import { useLazyQuery, NetworkStatus, useQuery } from '@apollo/client';
import {
  APIDOMAIN,
  apiEndpoint,
  MetadataElementIdConstants
} from '@ibinder/common-utils';

// Components
import { BinderContent, Flexbox } from '@ibinder/common-frontend';
import SearchableDropDown from './SearchableDropDown';
import UploadFileButton from './UploadFileButton';

// Utils
import { GET_ALL_ORGS } from '../../api/queries/queries_local';
import { getAppSetting } from '../../../Shared/ApplicationSettings';
import { binderTemplateDataSchema } from './FormValidation';

// Icons
import {
  check as checkIcon,
  close,
  exclamationCircle
} from '@ibinder/common-icons';

import {
  FormContainer,
  StyledButton,
  Icon,
  StyledDocumentActionsSnackbar,
  StyledToolButton
} from './form.styles';

const UploadTemplateForm = () => {
  const [appStatus, setAppStatus] = useState(null);
  const [responseMsg, setResponseMsg] = useState('');
  const [formCompleted, setFormCompleted] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [selectedType, setSelectedType] = useState({
    organization: null,
    facilityFile: null
  });
  const orgs = useQuery(GET_ALL_ORGS, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });

  const getSelectedValues = () => {
    return {
      organizationId: orgs.data.get[selectedType.organization].id,
      facilityFile: selectedType.facilityFile
    };
  };

  useEffect(() => {
    // Reset other selections upon repicking an organization
    setFormCompleted(false);

    // Set selected organizations tenant id in localstorage so authLink can accesss it
    if (orgs.data && selectedType.organization !== null) {
      localStorage.setItem(
        'tenantId',
        orgs.data.get[selectedType.organization].id
      );
    }
  }, [selectedType.organization]);

  const UPLOAD_FILE = (file) => {
    // selectedType.facilityFile
    // This will upload the file after having read it
    const formDatas = new FormData();
    formDatas.append('file', file, file.name);

    const adminEnpdoint = apiEndpoint(getAppSetting('REACT_APP_API_URL'))(
      APIDOMAIN.binders
    );

    return fetch(`${adminEnpdoint}/templates/fromfile`, {
      //TODO: CHECK THIS?
      method: 'POST',
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'x-ibinder-tenantid': localStorage.getItem('tenantId')
      },
      body: formDatas
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const adminData = getSelectedValues();
    setPostLoading(true);
    binderTemplateDataSchema
      .validate(adminData, { abortEarly: false })
      .then(() => {
        setResponseMsg('');

        UPLOAD_FILE(selectedType.facilityFile).then((res) => {
          if (res.status !== 200) {
            return res.text().then((text) => {
              setResponseMsg(text);
              setAppStatus('error');
            });
          }
          if (res.status === 200) {
            setSelectedType({
              organization: null,
              facilityFile: null
            });
            setResponseMsg(res.statusText);
            setAppStatus('done');
          }
          setPostLoading(false);
        });
      });
  };

  return (
    <BinderContent loading={orgs.loading ? true : undefined}>
      <FormContainer onSubmit={handleSubmit} enctype="multipart/form-data">
        {appStatus && (
          <StyledDocumentActionsSnackbar
            state={appStatus === 'done' ? appStatus : 'error'}
            animationEnabled={true}
            action={
              <StyledToolButton
                type="button"
                onClick={() => setAppStatus(null)}
              >
                <span>{close}</span>
              </StyledToolButton>
            }
          >
            <Flexbox alignItems="center">
              <Icon>
                {appStatus === 'done' ? checkIcon : exclamationCircle}
              </Icon>
              <span>{responseMsg}</span>
            </Flexbox>
          </StyledDocumentActionsSnackbar>
        )}

        {orgs && !selectedType.organization && (
          <SearchableDropDown
            {...{ selectedType, setSelectedType }}
            label="Organization"
            data={orgs.data && orgs.data.get}
            loading={orgs.networkStatus !== NetworkStatus.ready}
            type="organization"
          />
        )}
        {selectedType.organization !== null && (
          <div>
            <h2>Upload excel here</h2>
            <UploadFileButton {...{ setSelectedType, setFormCompleted }} />
          </div>
        )}

        <StyledButton
          data-test="submit-btn"
          btnType="regular"
          btnStyle="primary"
          label="Submit"
          type="submit"
          disabled={!formCompleted}
        />
        {postLoading && <div>Sending data...</div>}
      </FormContainer>
    </BinderContent>
  );
};

export default UploadTemplateForm;
